module.exports = __webpack_public_path__ + "img/1.ca8655e6.png";